// SPDX-License-Identifier: AGPL-3.0-or-later
/**
 * Ordered registry of field type handlers. Lookup walks entries in
 * declaration order and returns the first whose `matches` predicate is
 * true. Custom registrations should land **before** generic fallbacks
 * when they share an `item.type` — use `registerBefore` for that.
 */
export class FieldTypeRegistry {
    entries = [];
    /** Append a registration to the end of the registry. */
    register(entry) {
        this.entries.push(entry);
    }
    /**
     * Insert `entry` immediately before the existing registration with the
     * given `beforeId`. Used by extensions that need to win over a generic
     * fallback (e.g. a phone field that should beat short-text).
     */
    registerBefore(beforeId, entry) {
        const idx = this.entries.findIndex((e) => e.id === beforeId);
        if (idx === -1) {
            this.entries.push(entry);
            return;
        }
        this.entries.splice(idx, 0, entry);
    }
    /** Look up the component for an item. Returns `undefined` if nothing matches. */
    resolve(item) {
        return this.entries.find((e) => e.matches(item));
    }
    /** Defensive snapshot — callers cannot mutate the internal array. */
    list() {
        return [...this.entries];
    }
    /** Returns a shallow clone — handy for tests that mutate without leaking state. */
    clone() {
        const copy = new FieldTypeRegistry();
        for (const e of this.entries)
            copy.register(e);
        return copy;
    }
}
//# sourceMappingURL=registry.js.map